<template>
  <li class="col-auto c-pl-1 c-pt-1 c-lg:c-pt-2 c-lg:c-pl-2">
    <div
      v-tooltip="{ content: propertyData.name, theme: 'baseTooltip' }"
      class="stretched-link"
    >
      <Component
        :is="getSvgBySystemName(propertyData.systemName)"
        class="icon"
        width="30"
        height="30"
      />
    </div>
  </li>
</template>

<script setup>
import { getSvgBySystemName } from '@/components/svg/properties/propertiesSvgs'

defineProps({
  propertyData: {
    type: Object,
    default() {
      return {}
    },
  },
})
</script>
